import { Button, Divider, FormControl, FormLabel, Heading, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Switch, useDisclosure, useToast } from "@chakra-ui/react";
import React from "react";
import axios from "axios";
import { useState } from "react";
import { ChatState } from "../../../Context/ChatProvider";
import { useEffect } from "react";


function Student_crud({ tittle, setFetchAgain }) {

	const { isOpen, onOpen, onClose } = useDisclosure()


	const toast = useToast();
	const [studentId, setStudentId] = useState("");
	const [name, setName] = useState("");
	const [dob, setDob] = useState("");
	const [nationality, setNationality] = useState("");
	const [phone, setPhone] = useState("");
	const [email, setEmail] = useState("");
	const [levels, setLevels] = useState("");
	const [group, setGroup] = useState("");
	const [reduction, setReduction] = useState("");
	const [reso, setRes] = useState("");
	const [restPayement, setRestPayement] = useState(true);
	const [picLoading, setPicLoading] = useState(true);
	const [typcour, setTypCour] = useState("");
	const [timecour, setTimeCour] = useState("");

	const [fetchLevelAgain, setFetchLevelAgain] = useState(true);
	const [levelTable, setLevelTable] = useState([]);
	const [groupTable, setGroupTable] = useState([]);
	const [etat, setEtat] = useState("true");
	const [dff, setDateEndFormation] = useState();

	const { user } = ChatState();

	const openModal = () => {
		setStudentId("");
		setName("");
		setDob("");
		setNationality("");
		setPhone("");
		setEmail("");
		setLevels("");
		setGroup("");
		setTimeCour("");
		setTypCour("");
		setReduction("");
		setRes("");
		setEtat('true')
		setDateEndFormation("");

		setRestPayement(0);
		setPicLoading(false);
		onOpen()
	}
	useEffect(() => {
		if (user != undefined)
			getAllLevels();
	}, [fetchLevelAgain === true || user != undefined])

	async function getAllLevels() {
		try {
			setLevelTable([])

			const config = {
				headers: {
					Authorization: `Bearer ${user.token}`,
				},
			};
			const { data } = await axios.get(`/api/level`, config)



			setLevelTable(data)

			setFetchLevelAgain(false)

		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: "Échec du chargement des résultats de recherche",
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom-left",
			});
		}

	};

	async function getGroups(name) {
		try {
			setGroupTable([])

			setGroup('');
			const config = {
				headers: {
					Authorization: `Bearer ${user.token}`,
				},
				params: { levelname: name }
			};
			const { data } = await axios.get(`/api/group`, config)



			setGroupTable(data)
			setLevels(name)




		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: "Échec du chargement des résultats de recherche",
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom-left",
			});
		}

	};

	const registerStudent = async () => {

		if (!studentId || !name || !dob || !nationality || !phone || !email || !levels || !group || !typcour || !timecour) {
			toast({
				title: "Veuillez remplir tous les champs",
				status: "warning",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});
			setPicLoading(false);
			return;
		}
		setFetchAgain(false);
		try {
			const config = {
				headers: {
					"Content-type": "application/json",
					Authorization: `Bearer ${user.token}`,
				},
			};
			await axios.post(
				"/api/student",
				{
					studentId,
					name,
					dob,
					nationality,
					phone,
					email,
					levels,
					group,
					reduction,
					restPayement,
					reso,
					dff,
					typcour,
					timecour 

				},
				config
			);
			let oper = "+";
			await axios.put(
				"/api/group/nb",
				{
					group,
					oper

				},
				config
			);
			setFetchAgain(true);
			toast({
				title: "Inscription réussie",
				status: "success",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});

		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: error.response.data.message,
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});

		}
		onClose()
	};


	return <>
		<Button bg='gray.50' className="p-2" onClick={() => { openModal() }}><i className="fa-solid fa-plus text-blue-400 mx-2"></i>Nouvel Etudient	</Button>
		<Modal

			isOpen={isOpen}
			onClose={onClose}
			size={"3xl"}
		>
			<ModalOverlay />

			<ModalContent m={'auto'}  >
				<ModalHeader className="bg-gray-50 shadow-md text-black text-xl"><i className="fa-solid fa-graduation-cap text-3xl"></i> Etudient</ModalHeader>


				<ModalBody pb={6}>
					<div className="flex flex-wrap mt-5 justify-between">

						<div>
							<Heading as='u' size='sm' >
								Information Personel
							</Heading>
							<div className="mr-4">
								<FormControl mt={2}>
									<Input id='id' placeholder='Id' value={studentId}
										onChange={(e) => setStudentId(e.target.value)} />
								</FormControl>
								<FormControl mt={2}>
									<Input id='name' placeholder='Nom et Prenom' value={name}
										onChange={(e) => setName(e.target.value)} />
								</FormControl>

								<FormControl mt={4}>
									<Input placeholder='Date de naissance' id='dob' value={dob}
										onChange={(e) => setDob(e.target.value)} />
								</FormControl>

								<FormControl mt={4}>
									<Input placeholder='Nationality' id='nationality' value={nationality}
										onChange={(e) => setNationality(e.target.value)} />
								</FormControl>

								<FormControl mt={4}>

									<Input placeholder='Telephone' id='yearsOf' value={phone}
										onChange={(e) => setPhone(e.target.value)} />
								</FormControl>
								<FormControl mt={4}>

									<Input placeholder='Email' id='yearsOf' value={email}
										onChange={(e) => setEmail(e.target.value)} />
								</FormControl>
								
								<FormControl mt={4} w={"58"}>

									<select className="w-full border p-2" defaultValue={reso !== '' ? reso : 'def'} value={reso !== '' ? reso : 'def'} onChange={(e) => { setRes(e.target.value) }}>
										<option value="def" defaultChecked disabled>Choiser le Raison de L'étude</option>
										<option value='1'>Travailler en Allemagne</option>
										<option value='2'>Ausbildung en Allemagne</option>
										<option value='3'>Études en Allemagne</option>
										<option value='4'>Visa & séjour</option>
									</select>

								</FormControl>


							</div>

						</div>


						<div>
							<Heading as='u' size='sm'>
								Class
							</Heading>

							<FormControl mt={2}>

								<select defaultValue={levels !== '' ? levels : 'def'} value={levels !== '' ? levels : 'def'} className="w-full border p-2" onChange={(e) => { getGroups(e.target.value) }}>
									<option value="def" defaultChecked disabled>Choiser un Niveaux</option>
									{
										levelTable.map((level) => {
											return <option value={level.levelName}>{level.levelName}</option>
										})
									}
								</select>

							</FormControl>

							<FormControl mt={4} w={"52"}>

								<select className="w-full border p-2" defaultValue={group !== '' ? group : 'def'} value={group !== '' ? group : 'def'} onChange={(e) => { setGroup(e.target.value) }}>
									<option value="def" defaultChecked disabled>Choiser un Group</option>
									{

										groupTable.map((groupe) => {

											return <option value={groupe.groupName}>{groupe.groupName} <span>{groupe.groupType === "Hybride" ? "( Hybride )" : ""}</span></option>
										})
									}
								</select>

							</FormControl>

							<FormControl mt={4}>
									<Input placeholder='Type de cours' id='typcour' value={dob}
										onChange={(e) => setTypCour(e.target.value)} />
								</FormControl>

								<FormControl mt={4}>
									<Input placeholder="Temps d'étude" id='timecour' value={nationality}
										onChange={(e) => setTimeCour(e.target.value)} />
								</FormControl>

						</div>


						<div className="w-40">
							<Heading as='u' size='sm'>
								Statut
							</Heading>
							<FormControl mt={2}>
								<select onChange={(e) => { setEtat(e.target.value) }}>
									<option value='true'>Actif</option>
									<option value='false'>Arrêté</option>
								</select>
							</FormControl>
							<FormControl mt={4} display={etat == 'true' ? 'none' : 'block'}>
								<input className="border w-40 h-10 rounded-md py-2 px-1" type="date" name="dateEndFormation" value={etat == 'false' ? dff : ""}
									onChange={(e) => setDateEndFormation(e.target.value)} />
							</FormControl>
						</div>

					</div>
				</ModalBody>

				<ModalFooter>
					<Button colorScheme='blue' mr={3}
						onClick={registerStudent}
						isLoading={picLoading}>
						Enregistrer
					</Button>
					<Button onClick={onClose}>Annuler</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	</>
}

export default Student_crud